module.exports = __webpack_public_path__ + "img/elemento_pc_down_selected.764132c0.svg";